(function ($) {
    'use strict';

    if (window.location.href.indexOf('thank-you') === -1) {
        // only run this on the thank you page
        return;
    }

    $(window).load(async function () {
        if (!window.purchase.hasMadePurchase()) {
            console.log(
                'THANK_YOU: Purchase already tracked, redirecting to my account'
            );
            // no purchase recorded, or it has already been dealt with, redirect
            window.location.href = '/my-account/overview';
            return;
        }

        console.log('THANK_YOU: Items purchased:', window.purchase.items);

        const totalPriceEl = document.querySelector(
            '#total-price .elementor-heading-title'
        );
        const firstNameEl = document.querySelector('.kl-js-fn');
        const lastNameEl = document.querySelector('.kl-js-ln');
        const emailEl = document.querySelector('.kl-js-email');
        const phoneEl = document.querySelector('.kl-js-phone');
        const addressEl = document.querySelector('.kl-js-address');

        let purchasedSubscription = false;
        let purchasedBody = false;
        let purchasedNightCream = false;
        let purchasedDayScript = false;

        window.purchase.items.forEach(function (item) {
            let product = item.getProduct();

            if (product.isSubscription) {
                purchasedSubscription = true;
            }

            if (product.isBody) {
                purchasedBody = true;
            }

            if (product.isNightCream) {
                purchasedNightCream = true;
            }

            if (product.isDayScript) {
                purchasedDayScript = true;
            }
        });

        const totalUpsellDiscountAmount = await window.purchase.checkout.totalUpsellDiscountAmount;
        
        let finalTotal = Math.max(
            0,
            window.purchase.checkout.total - totalUpsellDiscountAmount
        );

        // Fill in user information in the Shipping Address section
        if (totalPriceEl) {
            totalPriceEl.textContent = '£' + finalTotal.toFixed(2);
        }
        if (firstNameEl) {
            firstNameEl.textContent =
                window.purchase.checkout.billing.first_name;
        }
        if (lastNameEl) {
            lastNameEl.textContent = window.purchase.checkout.billing.last_name;
        }
        if (emailEl) {
            emailEl.textContent = window.purchase.checkout.email;
        }
        if (phoneEl) {
            phoneEl.textContent = window.purchase.checkout.phone;
        }
        if (addressEl) {
            addressEl.textContent = `${window.purchase.checkout.billing.address}, ${window.purchase.checkout.billing.city}, ${window.purchase.checkout.billing.zip}, United Kingdom`;
        }

        // combine all subscription IDs and order IDs together for tracking
        let trackedTransactionIds = []
            .concat(window.purchase.checkout.chargebeeSubscriptionIds)
            .concat(window.purchase.checkout.chargebeeInvoiceIds);

        if (!window.customer) {
            console.error('Customer data missing!');
            return;
        }

        // Replaced by server-side purchase_v2 GTM event (now 'purchase') injected on the thank-you page.
        // Kept here for reference.
        // window.dataLayer = window.dataLayer || [];
        // const numberOfExistingSubscriptions =
        //     window.customer.subscriptions?.objects?.[0]?.items?.length ?? 0;
        // const numberOfPurchasedSubscriptions = window.purchase.checkout?.chargebeeSubscriptionIds?.length ?? 0;
        // const hasEndedPurchasedSubscriptions =
        //     window.customer.subscriptions.hasEndedBodySubscription() ||
        //     window.customer.subscriptions.hasEndedDayScriptSubscription() ||
        //     window.customer.subscriptions.hasEndedNightCreamSubscription();
        // const hasPurchasedSubscriptionItem =
        //     window.purchase.hasPurchasedSubscription();
        // let customerType;
        // if (
        //     hasPurchasedSubscriptionItem &&
        //     numberOfExistingSubscriptions === numberOfPurchasedSubscriptions
        // ) {
        //     customerType = hasEndedPurchasedSubscriptions
        //         ? 'existing_with_past_subscription'
        //         : 'new_subscriber';
        // } else if (numberOfExistingSubscriptions > 0) {
        //     customerType = 'existing_subscriber';
        // } else if (hasEndedPurchasedSubscriptions) {
        //     customerType = 'existing_with_past_subscription';
        // } else {
        //     customerType = 'non_subscriber';
        // }
        // window.dataLayer.push({
        //     event: 'purchase',
        //     ecommerce: {
        //         transaction_id: trackedTransactionIds.join('|'),
        //         affiliation: 'Online Store',
        //         value: finalTotal,
        //         currency: 'GBP',
        //         coupons: window.purchase.coupons.map(function (coupon) {
        //             return coupon.code;
        //         }),
        //         customer_type: customerType,
        //         purchase_types: window.purchase.getPurchaseTypes(),
        //         items: window.purchase.items.map(function (item) {
        //             let product = item.getProduct();
        //             return {
        //                 item_id: product.chargebeeAddOnId ?? product.id,
        //                 item_name: product.name,
        //                 item_category: product.id,
        //                 price: product.price,
        //                 quantity: item.quantity,
        //                 subscription_length: product.subscription_length,
        //             };
        //         }),
        //     },
        // });

        if (typeof window.tracking.awin !== 'undefined') {
            window.tracking.awin.send(
                finalTotal,
                trackedTransactionIds.join('|'),
                window.purchase.coupons,
                window.customer.id
            );
        }
        // clear the purchase so we don't record it again
        window.purchase.clear();
        window.upsellDiscounts.clear();

        // Add an info message depending on what they purchased
        const redirectionMessage = document.createElement('div');

        const multiPurchase =
            (purchasedBody && purchasedNightCream) ||
            (purchasedBody && purchasedDayScript) ||
            (purchasedNightCream && purchasedDayScript);

        if(!multiPurchase) {
            if (purchasedBody) {
                // add a message for body customers telling them that we'll redirect to collect more info
                redirectionMessage.textContent =
                    'Thank you for purchasing Klira Body. We need to gather some more details in order to fulfil your prescription, please wait while we redirect you.';
            } else if (purchasedNightCream) {
                // add a message for night cream customers telling them that we'll redirect
                redirectionMessage.textContent =
                    'Thank you for purchasing The Klira Special. We need to gather some more details in order to fulfil your prescription, please wait while we redirect you.';
            } else if (purchasedDayScript) {
                // add a message for day script customers telling them that we'll redirect
                redirectionMessage.textContent =
                    'Thank you for purchasing The Day Script. You will be redirected to your account in a few seconds.';
            }
        }

        totalPriceEl
            .closest('.elementor-element')
            .appendChild(redirectionMessage);

        //redirect to my account overview page
        setTimeout(() => {
            // Only redirect if an upsell offer is not being displayed.
            if ($('#klira-upsell-offer-container').children().length === 0) {
                window.location.href = '/my-account/overview';
            }
        }, 5000);
    });
})(jQuery);

